import axios from 'axios';
import React, { useEffect, useState } from 'react'

const GlobalCandidateSettings = ({ userId, isSomeChanges }) => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const [totalJobsToApplyPerDay, setTotalJobsToApplyPerDay] = useState(0);
  const [countOfAppliedJobsByDay, setCountOfAppliedJobsByDay] = useState(0);
  useEffect(() => {
    const fetchTotalJobsToApplyPerDay = async () => {
      try {
        const response = await axios.get(`${BASE_API_URL}/totalJobsToApplyPerDay`, {
          params: { userId } // Assuming userId is sent as a query parameter
        });
        if (response.data) {
          setTotalJobsToApplyPerDay(response.data);
        }
      } catch (error) {
        console.error('Error fetching total Jobs To Apply Per Day:', error);
      }
    };

    if (userId) {
      fetchTotalJobsToApplyPerDay();
      fetchTotalAppliedJobsPerDayByUser();
    }
  }, [userId, isSomeChanges]);

  const fetchTotalAppliedJobsPerDayByUser = async () => {
    try {
      const response = await axios.get(`${BASE_API_URL}/getAppliedJobsPerDayByUser`, {
        params: { userId } // Assuming userId is sent as a query parameter
      });
      if (response.data) {
        setCountOfAppliedJobsByDay(response.data);
      }
    } catch (error) {
      console.error('Error fetching Applied Jobs Per Day By User:', error);
    }
  };
  return (
    <div style={{
      border: '1px solid #ccc',
      borderRadius: '8px',
      padding: '12px 16px',
      backgroundColor: '#f9f9f9',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      fontSize: '14px'
    }}>
      <span>
        Your Daily Limit: {totalJobsToApplyPerDay} | Applied Today: {countOfAppliedJobsByDay} |&nbsp;
        <a href="mailto:ping@jobbox.one" style={{ textDecoration: 'underline', color: '#007bff' }}>
          Get Additional Credit
        </a>
      </span>
    </div>
  )
}

export default GlobalCandidateSettings